import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DnnInterceptor } from './Service/Dnn/dnn-interceptor';
// import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DatosComponent } from './componentes/actualizacion-datos/datos.component';
import { CargadorComponent } from './componentes/compartido/cargador/cargador.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DnnContextService } from './Service/Dnn/dnncontext.service';
// import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'; /*This generates error on Dnn*/
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
/* Angular Material Components */
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatRadioModule} from '@angular/material/radio';
import { AdminDatosComponent } from './componentes/admin-datos/admin-datos.component';
import { CustomMatCatComponent } from './componentes/custom-mat-cat/custom-mat-cat.component';
import { EmailValidationConfigService } from './Service/correo-validacion-config.service';
import { APP_INITIALIZER } from '@angular/core';

export function initEmailConfig(configService: EmailValidationConfigService) {
  return () => configService.load();
}

// export function loadEmailConfig(
//   configService: EmailValidationConfigService
// ) {
//   return () => configService.load();
// }

@NgModule({
  declarations: [
    AppComponent,
    DatosComponent,
    CargadorComponent,
    AdminDatosComponent,
    CustomMatCatComponent
  ],
  imports: [
    BrowserModule,
    // AppRoutingModule
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
     /* Angular Material Components */
     MatInputModule,
     MatFormFieldModule,
     BrowserAnimationsModule,
     MatDatepickerModule,
     MatNativeDateModule,
     MatSelectModule,
     MatButtonModule,
     MatCheckboxModule,
     MatTableModule,
     MatPaginatorModule,
     MatRadioModule
  ],
  providers: [
    { provide: APP_INITIALIZER, 
      useFactory: initEmailConfig, 
      deps: [EmailValidationConfigService], 
      multi: true },
    {
    provide: HTTP_INTERCEPTORS,
    useClass: DnnInterceptor,
    // useFactory: loadEmailConfig,
    // deps: [EmailValidationConfigService],
    multi: true
   }, 
   DnnContextService, /*provideAnimationsAsync()*/ /*This generates error on Dnn*/
],
  bootstrap: [AppComponent]
})
export class AppModule { }
